import { ManualPaymentConfiguration } from './manual-payment-configuration.model';

export type PaymentConfiguration = {
  allowedPaymentTypes: PaymentType[];
  manualPaymentConfiguration?: ManualPaymentConfiguration;
  minimumPaymentAmount: number;
  maximumPaymentAmount: number;
};

export type PaymentType = 'MANUAL_PAYMENT' | 'CREDIT_CARD' | 'SEPA' | 'GIRO' | 'PAYPAL';
export type SelectablePaymentType = Exclude<PaymentType, 'MANUAL_PAYMENT'>;

export function getSelectablePaymentTypes(paymentTypes: PaymentType[]): SelectablePaymentType[] {
  return paymentTypes.filter((paymentType) => paymentType != 'MANUAL_PAYMENT') as SelectablePaymentType[];
}

export function hasManualPayment(
  paymentConfiguration: PaymentConfiguration,
): paymentConfiguration is PaymentConfiguration & { manualPaymentConfiguration: ManualPaymentConfiguration } {
  return paymentConfiguration.allowedPaymentTypes.includes('MANUAL_PAYMENT');
}
